<template>
  <div ref="spotlight" class="spotlight-container">
    <div class="spotlight" :style="'height: ' + calculateHeight() + ';'">
      <HostVideo
        v-if="
          Object.keys(spotlightPeer.videoConsumer).length !== 0 &&
          spotlightPeer.role === 'host' &&
          !spotlightPeer.vidPaused &&
          renderComponent &&
          !isPeerMe
        "
        :peer="spotlightPeer"
      />
      <div v-if="isPeerMe" class="own-video-container">
        <video ref="videoElem" autoPlay="true" playsInline="true" muted />
      </div>
    </div>

    <div ref="hostUsersContainer" class="host-users">
      <div
        v-for="peer in hostPeers"
        :key="peer.id"
        class="remote-user spotlight-user"
        :class="[activeSpeaker.id === peer.id ? 'active' : '']"
      >
        <div class="remote-user-aspect-helper">
          <HostVideo
            v-if="Object.keys(peer.videoConsumer).length !== 0 && peer.role === 'host' && !peer.vidPaused"
            :peer="peer"
            :width="width"
            :current-user-count="10"
            class="remote-user-inner"
          />
          <HostNoVideo
            v-else-if="peer.role === 'host'"
            :peer="peer"
            :width="width"
            :current-user-count="10"
            class="remote-user-inner"
          />
        </div>
      </div>
      <div v-for="number in testuser" :key="number" class="remote-user spotlight-user">
        <div class="remote-user-aspect-helper">
          <img class="remote-user-inner" src="https://picsum.photos/1920/1080" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/**
 * Layout for spotlighted Users
 * @displayName Spotlight
 */
import { mapState } from "vuex";
import HostVideo from "./HostVideo.vue";
import HostNoVideo from "./HostNoVideo.vue";

export default {
  name: "Spotlight",
  components: {
    HostVideo,
    HostNoVideo,
  },
  props: {},
  data() {
    return {
      width: "360px",
      spotlightHeight: 0,
      spotlightWidth: 0,
      testuser: 0,
      renderComponent: true,
    };
  },
  computed: {
    ...mapState({
      isSpotlight: (state) => state.mediasoup.isSpotlight,
      displayName: (state) => state.mediasoup.displayName,
      spotlightPeerId: (state) => state.mediasoup.spotlightPeerId,
      mediasoupId: (state) => state.mediasoup.mediasoupId,
      activeSpeaker: (state) => state.mediasoup.activeSpeaker,
      peers: (state) => state.mediasoup.peers,
    }),
    isPeerMe() {
      if (this.mediasoupId === this.spotlightPeerId) {
        return true;
      } else {
        return false;
      }
    },
    hostPeers() {
      let hostpeers = this.peers.filter(
        (peer) => peer.role === "host" && peer.id !== this.mediasoupId && peer.id !== this.spotlightPeerId,
      );
      console.log("host peers", hostpeers);
      return hostpeers;
    },
    spotlightPeer() {
      let peer = this.$store.getters["mediasoup/getAllPeers"].filter((peer) => peer.id === this.spotlightPeerId)[0];
      console.log("spotlighted peer", peer);
      return peer;
    },
  },
  watch: {
    spotlightPeerId() {
      this.forceRerender();
    },
    isPeerMe(val) {
      if (val) {
        const stream = new MediaStream();
        let videoProducer = this.$store.getters["mediasoup/videoProducer"];
        stream.addTrack(videoProducer.track);
        console.log("mestream", stream.getTracks());
        this.$nextTick(function () {
          this.$refs.videoElem.srcObject = stream;
          this.$refs.videoElem.play().catch((error) => console.log("videoElem.play() failed:%o", error));
        });
      }
    },
  },

  created() {
    if (this.isPeerMe) {
      const stream = new MediaStream();
      let videoProducer = this.$store.getters["mediasoup/videoProducer"];
      stream.addTrack(videoProducer.track);
      console.log("mestream", stream.getTracks());
      this.$nextTick(function () {
        this.$refs.videoElem.srcObject = stream;
        this.$refs.videoElem.play().catch((error) => console.log("videoElem.play() failed:%o", error));
      });
    }
  },

  mounted() {
    this.getSpotlightMeasurements();
    this.activateDragScroll();
  },

  unmounted() {
    console.log("Spotlight.vue unmounted");
    this.$refs.videoElem.srcObject = "";
  },

  methods: {
    randomColor() {
      const r = () => Math.floor(256 * Math.random());

      return `rgb(${r()}, ${r()}, ${r()})`;
    },
    calculateHeight() {
      // return correct value
      // console.log("height calc spotlight", `${this.spotlightHeight - 148}px`);
      return `${this.spotlightHeight - 148}px`;
    },
    /**
     * Calculates the height and width for the spotlight user's video
     */
    getSpotlightMeasurements() {
      if (this.$refs.spotlight) {
        this.$data.spotlightHeight = this.$refs.spotlight.clientHeight;
        this.$data.spotlightWidth = this.$refs.spotlight.clientWidth;

        console.log("height, width", this.$data.spotlightHeight, this.$data.spotlightWidth);
      } else {
        this.$data.spotlightHeight = -1;
        this.$data.spotlightWidth = -1;
      }
    },
    forceRerender() {
      // remove the HostVideo component from the DOM
      this.renderComponent = false;

      this.$nextTick(() => {
        // add HostVideo component in DOM
        this.renderComponent = true;
      });
    },
    // Drag scroll
    activateDragScroll() {
      const slider = this.$refs.hostUsersContainer;
      let isDown = false;
      let startX;
      let scrollLeft;

      slider.addEventListener("mousedown", (e) => {
        isDown = true;
        slider.classList.add("active");
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      });
      slider.addEventListener("mouseleave", () => {
        isDown = false;
        slider.classList.remove("active");
      });
      slider.addEventListener("mouseup", () => {
        isDown = false;
        slider.classList.remove("active");
      });
      slider.addEventListener("mousemove", (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = x - startX;
        slider.scrollLeft = scrollLeft - walk;
      });
    },
  },
};
</script>
<style scoped>
.spotlight-container {
  flex-direction: column;
}
.host-users {
  flex-shrink: 0;
  display: flex;
  width: 100%;
  height: auto;
  overflow-x: scroll;
  overflow-y: hidden;
  position: relative;
  justify-content: flex-start;
  align-content: center;
  flex-direction: row;
  margin: 0 -2px;
  cursor: pointer;
}
.host-users::-webkit-scrollbar {
  display: none;
}
.spotlight-user {
  min-width: 250px;
  max-width: 250px;
}
.spotlight {
  width: 100%;
  display: block;
  align-items: center;
  justify-content: center;
  /* height: 860px; */
  margin-bottom: 10px;
  position: relative;
  overflow: hidden;
}
.spotlight > video {
  width: 100%;
  height: 100%;
}
.own-video-container {
  min-height: 100%;
  height: 100%;
  padding-top: 5px;
  margin-left: auto;
  margin-right: auto;
  display: block;
}
/* scrollbar */
::-webkit-scrollbar {
  width: 2px;
  height: 6px;
}
::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
}
::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.3);
}
::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.5);
}
</style>
